import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Content } from '../../../../domain/content/content.model';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dottnet-grid-card',
  templateUrl: 'grid-card.component.html',
  styleUrls: ['grid-card.component.scss', '../../content-list-viewer.component.scss'],
  imports: [MatCardModule, RouterLink, MatIconModule]
})
export class GridCardComponent {
  readonly content = input<Content>(undefined);

  constructor() { }
}
